export enum PaymentStatus {
  SUCCESS = "success",
  CANCEL = "cancel",
  FAILURE = "failure",
  ERROR = "error",
}
